import axiosInstance from "../axiosInstance";

export const createOrder = async (request) => {
    return axiosInstance.post("/payment/create-order", request);
};

export const verifyPayment = async (payload) => {
    return axiosInstance.post("/payment/verify-payment", payload);
};

export const getWalletBalance = async () => {
    return axiosInstance.get("/payment/wallet/balance");
};